import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {HOME_HREF} from '../../../constants'
import {sendClickEvent} from '../../../utils/gtm-utils'

/**
 * Extracts the six navigation handler callbacks used by the App shell
 * (header, drawer menu, footer links).
 *
 * `authModal` and `accountModalProps` are passed in rather than created
 * internally because useAuthModal() owns its own useDisclosure state —
 * calling it twice would produce two independent open/close states.
 */
export const useNavigationHandlers = ({onDrawerClose, authModal, accountModalProps}) => {
    const navigate = useNavigation()
    const {data: customer} = useCurrentCustomer()

    const onLogoClick = () => {
        navigate(HOME_HREF)
        onDrawerClose()
    }

    const onCartClick = () => {
        navigate('/cart')
        onDrawerClose()
    }

    const onAccountClick = () => {
        accountModalProps.onOpen()
        sendClickEvent('prompt_sign_in_clicked')
    }

    const onWishlistClick = () => {
        if (customer?.isRegistered) {
            navigate('/account/wishlist')
            return
        }

        sendClickEvent('wishlist_cta_clicked')
        authModal.setIsWishlistClick(true)
        authModal.onOpen()

        navigate('/account/wishlist', 'push', {
            state: {from: {pathname: '/account/wishlist'}}
        })
    }

    const onLoyaltyClick = () => {
        navigate(customer?.isRegistered ? '/my-rewards' : '/account')
    }

    const onGiftCardClick = () => {
        navigate('/p/e-gift-card/GARGIFTCARDGBEGC001.html')
    }

    return {
        onLogoClick,
        onCartClick,
        onAccountClick,
        onWishlistClick,
        onLoyaltyClick,
        onGiftCardClick
    }
}
